import React from "react";
import { Text, View, StyleSheet } from "@react-pdf/renderer";

const styles = StyleSheet.create({
  titleContainer: {
    flexDirection: "row",
    marginTop: 10,
    marginBottom: 0,
  },
  reportTitle: {
    color: "#000000",
    fontSize: 12,
  },
});

const ReportTitle = ({ title }: any) => (
  <View style={styles.titleContainer}>
    <Text style={styles.reportTitle}>{title}</Text>
  </View>
);

export default ReportTitle;
